import { getConfigApi } from "../services/getConfigurations";
import { getChemicalsApi } from "../services/loadChemicals";
import { getStyleNumbersApi } from "../services/loadStyleNumbers";
import { getPermeationsApi } from "../services/getPermeations";
import { store } from "./gloveSelectorStore";
import { STORE_ACTION_TYPES } from "../helper/constants";
import { GloveSelectorAppState } from "../types/allTypes";
import { LANGUAGE_CHANGE_IND_HF } from "./initialStoreValues";
import { facetApi } from "../services/getFacets";
import { infoAreaApi } from "../services/getInfoArea";
export const initialState: GloveSelectorAppState = {
  calculator: {
    selectedChemicals: [],
    typeOfChemicalResultsSelected: "Minutes",
    selectedChemicalsArray: [],
    styleNumberArray: [],
    gloveResults: null,
    updatedOn: Date.now(),
    prevPagePath: "/",
    rowsPerPageValue: 10,
    isRestoredSessionUpdated: false,
    currentUserID: "",
  },
  config: undefined,
  language: "",
  appLanguageFlag: false,
  isAppKeyAdded:false,
  setFilterFacets: {},
  error: {
    showError: false,
    errorMessage: undefined,
    errorInfo: undefined,
    endpointName: undefined,
    errorMetaInfo: undefined,
  },
};

//get API for the end points
const getAPI = (endpointName) => {
  switch (endpointName) {
    case "getConfigurations":
      return getConfigApi;
      break;
    case "getChemicals":
      return getChemicalsApi;
      break;
    case "getStyleNumbers":
      return getStyleNumbersApi;
      break;
    case "getPermeations":
      return getPermeationsApi;
      break;
    case "getFacetResults":
      return facetApi;
      break;
      case "getInfoAreaResults":
      return infoAreaApi;
      break;
    default:
      return undefined;
      break;
  }
};
export const resetAllQuery = () => {
  if (store) {
    store.dispatch(getChemicalsApi?.util?.resetApiState());
    store.dispatch(getPermeationsApi?.util?.resetApiState());
  }
};
export const resetQuery = () => {
  const state = store.getState();
  const error = state?.glovesSelector?.error || {};
  const api = getAPI(error?.endpointName);
  if (api && store) {
    store.dispatch(api?.util?.resetApiState());
    store.dispatch({
      type: STORE_ACTION_TYPES.RESET_QUERY,
      payload: {},
    });
  }
};
//reducers
export const glovesSelectorReducer = (state = initialState, action: any) => {
  let { calculator, config, error, language, setFilterFacets, appLanguageFlag } = state || {};

  switch (action.type) {
    case STORE_ACTION_TYPES.APP_LANGUAGE_CHANGE:
      appLanguageFlag = action.payload;
      const newAppLanguageState = { ...state, appLanguageFlag: appLanguageFlag };
      return newAppLanguageState as GloveSelectorAppState;
      case STORE_ACTION_TYPES.SET_KEY_STATUS:       
        const newKeyStatusState = { ...state, isAppKeyAdded: true };
        return newKeyStatusState as GloveSelectorAppState;
      case STORE_ACTION_TYPES.LANGUAGE_CHANGE_IND_HF:
        language = action.payload;
        const newLanguageState = { ...state, language: language };
        return newLanguageState as GloveSelectorAppState;
      case STORE_ACTION_TYPES.SET_FILTER_FACETS:
        setFilterFacets = action.payload;
        const newFilterFacetsState = { ...state, setFilterFacets: setFilterFacets };
        return newFilterFacetsState as GloveSelectorAppState;

    case STORE_ACTION_TYPES.USER_SELECTED_CHEMICALS:
      calculator = {
        ...calculator,
        selectedChemicals: action?.payload,
        ...action.payload,
      };
      const newSelectedChemState = { ...state, calculator: calculator };
      return newSelectedChemState as GloveSelectorAppState;

      case STORE_ACTION_TYPES.PRODUCT_STYLE_NUMBERS_ARRAY:
        calculator = {
          ...calculator,
          styleNumberArray: action?.payload,
          ...action.payload,
        };
        const styleNumberState = { ...state, calculator: calculator };
      return styleNumberState as GloveSelectorAppState;

    case STORE_ACTION_TYPES.CALCULATOR:
      calculator = {
        ...calculator,
        typeOfChemicalResultsSelected: action?.payload,
        ...action.payload,
      };
      const newSelectedChemResultsTypeState = {
        ...state,
        calculator: calculator,
      };
      return newSelectedChemResultsTypeState as GloveSelectorAppState;

    case STORE_ACTION_TYPES.USER_SELECTED_CHEMICALS_ARRAY:
      calculator = {
        ...calculator,
        selectedChemicalsArray: action?.payload,
        ...action.payload,
      };
      const newSelectedChemArrayState = { ...state, calculator: calculator };
      return newSelectedChemArrayState as GloveSelectorAppState;

    case STORE_ACTION_TYPES.GLOVE_RESULTS:
      calculator = {
        ...calculator,
        gloveResults: action?.payload,
        ...action.payload,
      };
      const newGloveResultsState = { ...state, calculator: calculator };
      return newGloveResultsState as GloveSelectorAppState;

    case STORE_ACTION_TYPES.RESET_CALCULATOR:
      calculator = action.payload;
      const newResetState = { ...state, calculator: calculator };
      return newResetState as GloveSelectorAppState;

    case STORE_ACTION_TYPES.ERROR:
      error = action.payload;
      const newErrorState = { ...state, error: error };
      return newErrorState as GloveSelectorAppState;

    case STORE_ACTION_TYPES.RESET_QUERY:
      const preCalculator = { ...calculator, updatedOn: Date.now() };
      const newQueryErrorState = {
        ...state,
        calculator: preCalculator,
        error: {
          ...error,
          showError: false,
          errorMessage: undefined,
          errorInfo: undefined,
          endpointName: undefined,
          errorMetaInfo: undefined,
        },
      };
      return newQueryErrorState as GloveSelectorAppState;

    case STORE_ACTION_TYPES.INIT:
      config = action.payload;
      const newConfiState = { ...state, config: config };
      return newConfiState as GloveSelectorAppState;

    case STORE_ACTION_TYPES.PERMEATIONS_QUERY:

    case STORE_ACTION_TYPES.FACET_QUERY:

    case STORE_ACTION_TYPES.CONFIG_QUERY:
      const { endpointName } = action?.meta?.arg;
      if (!action?.payload?.isSuccess) {
        const result = action?.payload?.result;
          const newConfiState = {
            ...state,
            calculator: { ...calculator, updatedOn: Date.now() },
            error: {
              showError: true,
              errorMessage: undefined,
              errorInfo: result,
              endpointName: endpointName,
              errorMetaInfo:
                {
                  endpointName: action?.meta?.arg?.endpointName || undefined,
                  url: action?.meta?.baseQueryMeta?.request?.url || "",
                  originalArgs: JSON.stringify(
                    action?.meta?.arg?.originalArgs || ""
                  ),
                } || undefined,
            },
          };
          return newConfiState as GloveSelectorAppState;
      }
      return state;
      break;
    default:
      return state;
  }
};
